import { FC, useMemo, useState } from 'react';
import { CardItemProps } from './CartItem.types';
import { Image, View, TouchableOpacity, Text } from 'react-native';
import { styles } from './CartItem.styled';
import { useIsDesktop } from '../../../../../hooks/useIsDeskTop';
import { convertHKPrice } from '../../../../../services/utils';
import { IS_WEB } from '../../../../../constants/platform';
import { addBase64Prefix } from '../../../../../services/addBase64Prefix';
import { close_icon } from '../../../../../assets/base64';

const CartItem: FC<CardItemProps> = ({
  item,
  onDelete,
  onDecreaseAmount,
  onIncreaseAmount,
}) => {
  const isDesktop = useIsDesktop();

  const closeButton = useMemo(() => {
    return (
      <TouchableOpacity
        onPress={() => {
          if (onDelete) onDelete(item.id);
        }}
        style={
          isDesktop()
            ? {
                marginLeft: 5,
                marginTop: 5,
                alignSelf: 'flex-start',
              }
            : {
                marginTop: 5,
                marginRight: 10,
              }
        }
      >
        <Image
          source={
            IS_WEB
              ? addBase64Prefix(close_icon)
              : require('../../../../../assets/close-icon.png')
          }
          style={{
            width: 14,
            height: 14,
          }}
        />
      </TouchableOpacity>
    );
  }, [isDesktop, onDelete, item.id]);

  return (
    <View
      style={{
        flexDirection: isDesktop() ? 'row' : 'column',
        marginBottom: 20,
        width: '100%',
      }}
    >
      <View style={isDesktop() && { width: '20%', flexDirection: 'row' }}>
        {isDesktop() && closeButton}
        <Text style={styles.titleText}>{item.type}</Text>
      </View>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'flex-start',
          width: isDesktop() ? '80%' : '100%',
        }}
      >
        <View
          style={[
            !isDesktop() && styles.tbody_content,
            {
              width: isDesktop() ? '37.5%' : '45%',
              flexDirection: 'row',
              paddingRight: isDesktop() ? 10 : 0,
            },
          ]}
        >
          {!isDesktop() && closeButton}
          <Text style={[styles.table_text, { textAlign: 'left' }]}>
            {item.productName}
          </Text>
        </View>
        <View
          style={[
            !isDesktop() && styles.tbody_content,
            {
              width: isDesktop() ? '18.75%' : '25%',
              paddingRight: isDesktop() ? 10 : 0,
            },
          ]}
        >
          <Text
            style={[
              styles.table_text,
              { textAlign: isDesktop() ? 'left' : 'center' },
            ]}
          >
            {convertHKPrice(item.price)}
          </Text>
        </View>
        <View
          style={[
            !isDesktop() && styles.tbody_content,
            {
              width: !isDesktop() ? '30%' : undefined,
              flex: isDesktop() ? 1 : undefined,
              flexDirection: isDesktop() ? 'row' : undefined,
            },
          ]}
        >
          <View
            style={[
              isDesktop()
                ? {
                    width: '60%',
                    justifyContent: 'flex-start',
                    flexDirection: 'row',
                  }
                : styles.countWrapper,
            ]}
          >
            <View style={styles.count}>
              <TouchableOpacity
                activeOpacity={1}
                style={styles.countBtn}
                onPress={() => {
                  if (item.amount && item.amount > 1 && onDecreaseAmount) {
                    onDecreaseAmount(item.id);
                  }
                }}
              >
                <Text style={styles.countBtnText}>-</Text>
              </TouchableOpacity>
              <Text style={styles.countText}>{item.amount || 1}</Text>
              <TouchableOpacity
                activeOpacity={1}
                style={styles.countBtn}
                onPress={() => {
                  if (item.amount && onIncreaseAmount) {
                    onIncreaseAmount(item.id);
                  }
                }}
              >
                <Text style={styles.countBtnText}>+</Text>
              </TouchableOpacity>
            </View>
          </View>
          <View
            style={
              isDesktop() && {
                width: '40%',
              }
            }
          >
            <Text
              style={[
                styles.table_text,
                { textAlign: isDesktop() ? 'center' : 'right' },
              ]}
            >
              {convertHKPrice(item.price * (item.amount || 1))}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default CartItem;
